import lightGallery from 'lightgallery';

document.addEventListener("DOMContentLoaded", function () {
    lightGallery(document.getElementById('fotogallerij'), {
        selector: '.lightbox',
        thumbnail: true,
    });    
});
